<template>
	<div class="field-wrapper spc">
		<template v-if="items && items.length">
			<div v-for="item in (readonly ? items.filter(fi => fi.id == curValue) : items)"
				class="spc__item"
				:key="item.id"
				:class="{
					'selected': item.id == curValue,
					'disabled': readonly || Props[item['id']]['disabled'],
					'not-active-item': item.active !== true,
					'narrow': crud === 'paymentauto' && action === 'create'
				}"
				@click="onItemClick(item.id)">
				<div class="spc__item-text">
					<div class="spc__item-name">
						<div class="spc__item-logo">
							<img :src="APIServerUrl + item.image" />
						</div>
						<div class="spc__item-pay-name">{{ item.name | ftc }}</div>
					</div>
				</div>			
				<div class="spc__item-info">
						<div v-if="item['comission'] > 0" class="spc__item-selector-info">
							{{ 'payment/comission' | ftc }}: {{ item['comission'] }}%
						</div>
						<div v-if="item['bonus'] > 0" class="spc__item-selector-info">
							{{ 'payment/bonus' | ftc }}: {{ item['bonus'] }}%
						</div>
						<div class="sm-sum">{{ Props[item['id']]['summa'] | moneyOnlyNumbers }}&nbsp;<span v-html="localeFtc('main/ruble')"></span></div>

						<template v-if="getMin(item) && getMax(item)">
							<div>{{ item['min'] | moneyOnlyNumbers }} &mdash; {{ item['max'] | moneyOnlyNumbers }} <span v-html="localeFtc('main/ruble')"> </span></div>
						</template>
						<template v-if="getMin(item) && !getMax(item)">
							<div>{{ 'main/range_from' | ftc }} {{ item['min'] | moneyOnlyNumbers }} <span v-html="localeFtc('main/ruble')"> </span></div>
						</template>
						<template v-if="!getMin(item) && getMax(item)">
							<div>{{ 'main/range_to' | ftc }} {{ item['max'] | moneyOnlyNumbers }} <span v-html="localeFtc('main/ruble')"> </span></div>
						</template>
				</div>
				<div class="spc__item-trash" :class="{ empty: crud === 'paymentauto' }" @click.stop="deleteSavedPayment(item.id)">
					<font-awesome-icon v-if="crud !== 'paymentauto'" icon="trash-alt" />
				</div>

			</div>
		</template>
		<!-- если список пустой и это автоплатежи: ничего не выводим -->
		<template v-else-if="crud === 'paymentauto'"></template>
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import { EventBus } from '@/bus.js'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	name: 'savedPaymentsComponent',

	//=========================================================================
	props: ['value', 'items', 'title', 'crud', 'action', 'readonly'],

	//=========================================================================
	computed: {
		currentItem() {
			if (!this.items || !this.items.length || !this.curValue) return null
			let item = null
			this.items.some(i => {
				if (i && i.id === this.curValue)
				{
					item = i
					return true
				}
			})

			return item
		}
	},

	//=========================================================================
	data() {
		return {
			curValue: null,
			curSumma: 0,
			Props: {}
		}
	},

	//=========================================================================
	created() {
		// параллельно ведем дополнительные свойства
		if (this.items && this.items.length)
		{
			this.items.forEach(item => {
				this.Props[item['id']] = {
					'active': item['active'],
					'disabled': false,
					'summa': 0
				}
			})
		}

		// устанавлилваем значение
		if (this.value !== undefined && this.value !== null)
			this.curValue = this.value

		// recountSum вызывать здесь не нужно
		// потому что будет установлена сумма в форме, и по этому событию
		// будет произведен вызов этой функции
	},

	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		// подписка на уведомления об изменении суммы
		// без дебаунса - что бы быстро менять расчетный суммы
		EventBus.$on('form-client-operation-create', this.summaChanged)
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		// отписка от уведомлений
		EventBus.$off('form-client-operation-create', this.summaChanged)
	},

	//=========================================================================
	methods: {
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// клик по тарифу
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onItemClick(id, isNextStep = true) {
			// эмуляция фокуса
			this.$emit('focus')

			// если итоговая сумма не задана
			if (!this.Props[id] ||
				this.Props[id]['summa'] === undefined ||
				this.Props[id]['summa'] === null ||
				isNaN(this.Props[id]['summa']) ||
				this.Props[id]['summa'] <= 0)
			{
				// ничего не делаем
				return
			}

			// ищем выбранный итем (в Props не все поля)
			let _item = null
			this.items.some(item => {
				if (String(item.id) === String(id))
				{
					_item = item
					return true
				}
			})
			// если не нашли
			if (!_item)
			{
				// ничего не делаем
				return
			}

			// если это клиент и кнопка неактивна
			if (this.$store.state.user_type !== 'admin' &&
				this.Props[id]['active'] !== true)
			{
				// ничего не делаем
				return
			}

			// способ неактивен
			if (this.Props[id]['disabled'] === true)
			{
				// ничего не делаем
				return
			}

			// значение корректно и оно доступно - запоминаем новое значение
			this.curValue = id

			// сообщаем родителю что у нас поменялось значение
			this.$emit('input', this.curValue)
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// событие: в форме изменилась сумма
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		summaChanged(summa) {
			// проверка входного параметра
			if (summa === undefined || summa === null || isNaN(summa)) summa = 0
			if (String(summa).length === 0) summa = 0

			// приводим к нужному виду для расчетов
			summa = parseFloat(summa)

			// обновляем переменную
			this.$set(this, 'curSumma', summa)

			// перерасчет итоговых сумм и доспуности кнопок
			this.recountSum()

			// данные не плоские - обновлять GUI нужно самим
			this.$forceUpdate()
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// перерасчет итоговой суммы и достуности кнопок
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		recountSum() {
			if (!this.items || !this.items.length) return
			if (!this.Props || !Object.keys(this.Props).length) return

			// ищем текущий способ
			let curPayment = null
			// бежим по всем способам
			this.items.forEach(item => {
				// если это текущий способ - запомним его
				if (item && String(item.id) === String(this.curValue))
				{
					curPayment = item
				}

				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// получим размер комиссии
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				let _com = item['comission']
				if (_com === undefined || _com === null || isNaN(_com) || _com === '') _com = 0
				_com = parseFloat(_com)

				// расчитаем итоговую сумму для данного способа оплаты
				let _price = (this.curSumma + _com * this.curSumma / 100.0).toFixed(2)
				_price = parseFloat(_price)

				// запоминаем ее
				this.Props[item['id']]['summa'] = _price

				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// получим минимальный и максимальный размеры
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// min
				let _min = item['min']
				if (_min === undefined || _min === null || isNaN(_min) || _min === '') _min = 0
				_min = parseFloat(_min)

				// max
				let _max = item['max']
				if (_max === undefined || _max === null || isNaN(_max) || _max === '') _max = 0
				_max = parseFloat(_max)

				// кнопка доступна или нет
				if (this.curSumma <= 0 || this.curSumma < _min || (_max && this.curSumma > _max))
				{
					this.Props[item['id']]['disabled'] = true
					this.Props[item['id']]['error'] = 'request/status_error: ' + (_max && this.curSumma > _max ? 'payment/max' : 'payment/min')
				}
				else
				{
					this.Props[item['id']]['disabled'] = false
					this.Props[item['id']]['error'] = ''
				}

				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			})

			// если нашли текущий способ - делаем проверки
			if (curPayment && curPayment.id)
			{
				// транслируем родителю значение
				if (curPayment.active !== true || this.Props[curPayment.id].disabled === true)
				{
					// если это редактирование автоплатежа
					if (this.crud === 'paymentauto' && this.action === 'update' && this.readonly)
					{
						// прокинем ошибку
						EventBus.$emit('w5-set-error-message', {
							field: 'summa',
							text: this.formater_capitalizeFirstChar(this.localeFtc(this.Props[curPayment['id']]['error']))
						})
						// транслировать ничего не нужно
						return
					}

					this.$emit('input', null)
				}
				else
					this.$emit('input', this.curValue)
			}
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// отдает минимальную сумму если есть, и null - если нет
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		getMin(item) {
			if (!item || !('min' in item) || item.min < 0) return null
			return item.min
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// отдает максимальную сумму если есть, и null - если нет
		// или если указано  магическое число
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		getMax(item) {
			if (!item || !('max' in item) || item.max < 0) return null
			if (item.max >= 1000000) return null
			return item.max
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// уведомляем родителя о том, что хотим удалить сохраненный способ
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		deleteSavedPayment(id) {
			if (!this.Props[id] || !this.Props[id].active || this.Props[id].disabled)
				return

			this.$emit('deleteSavedPayment', id)
		}

		//---------------------------------------------------------------------
	},

	//=========================================================================
	watch: {
		'value': function(value) {
			this.curValue = value
			this.recountSum()
		},
		'items': function(items) {
			if (!items || !items.length) return

			// параллельно ведем дополнительные свойства
			items.forEach(item => {
				this.Props[item['id']] = {
					'active': item['active'],
					'disabled': false,
					'summa': 0
				}
			})

			// при удалении сохраненного способа - нужно пересчитать все
			this.recountSum()
		}
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.spc__item {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	justify-content: space-between;
	-webkit-justify-content: space-between;

	align-items: center;
	-webkit-align-items: center;

	position: relative;
	height: 60px;
	cursor: pointer;
	margin-bottom: 15px;
	width: 100%;
}
.spc__item:last-of-type {
	margin-bottom: 0;
}

.spc__item-text {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	justify-content: space-between;
	-webkit-justify-content: space-between;

	align-items: flex-start;
	-webkit-align-items: flex-start;

	flex: 0 0 calc(100% - 190px);
	line-height: 1;
	font-size: 12px;
	font-weight: 500;
	border-radius: 6px 0 0 6px;
	border: 1px solid #ddd;
	height: 60px;
	padding-right: 10px;
	transition: all .2s;
}
.spc__item-name {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	justify-content: space-between;
	-webkit-justify-content: space-between;

	align-items: center;
	-webkit-align-items: center;
}
.spc__item-logo {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	justify-content: center;
	-webkit-justify-content: center;

	align-items: center;
	-webkit-align-items: center;

	height: 60px;
	width: 70px;
	margin: 0 10px 0 5px;
}
.spc__item-logo > img {
	max-width: 70px;
	max-height: 60px;
}
.spc__item-pay-name {
	display: inline-block;
	font-size: 15px;
}

.sm-sum {
	font-size: 11.4px;
	font-weight: 500;
}

.spc__item-info {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;
	flex-direction: column;

	justify-content: center;
	-webkit-justify-content: center;

	align-items: flex-start;
	-webkit-align-items: flex-start;

	flex: 0 0 160px;
	position: relative;
	height: 60px;
	font-size: 11.4px;
	font-weight: 300;
	padding-left: 10px;
	border-top: 1px solid #ddd;
	border-bottom: 1px solid #ddd;
	transition: all .2s;
}

.spc__item-trash {
	flex: 0 0 20px;
	color: #999;
	font-size: 14px;
	padding: 20px 10px;
	height: 60px;
	border-right: 1px solid #ddd;
	border-top: 1px solid #ddd;
	border-bottom: 1px solid #ddd;
	border-radius: 0 6px 6px 0;
	transition: all .2s;
	z-index: 1;
}
.spc__item-trash:hover {
	color: red;
}

.spc__item-trash.empty {
	flex: 0 0 30px;
}




.spc__item.selected .spc__item-text {
	background-color: #dceeff;
	border-color: #3ba3ff;
}
.spc__item.selected .spc__item-selector,
.spc__item.selected .spc__item-info,
.spc__item.selected .spc__item-trash {
	border-color: #3ba3ff;
}

.spc__item.disabled {
    color: #aaa;
	cursor: not-allowed
}
.spc__item.disabled img {
	opacity: 0.6;
}
.spc__item.disabled .spc__item-text {
	background-color: #eee;
	border-color: #ccc;
}
.spc__item.disabled .spc__item-selector,
.spc__item.disabled .spc__item-info,
.spc__item.disabled .spc__item-trash {
	border-color: #ccc;
}

.spc__item.disabled .spc__item-trash,
.spc__item.disabled .spc__item-trash:hover {
	color: #ccc;
}

.spc__item.narrow {
	margin-bottom: 1px
}

.empty-filed-title {
	font-size: 100%;
	font-weight: 400;
	color: red;
}

@media (max-width: 768px) {
	.spc__item {
		padding-right: 0;
		margin-bottom: 20px;		
	}
	.spc__item-text {
		flex: 0 0 calc(100% - 190px);
	}
	.spc__item-name {
		height: 60px;
	    padding-left: 10px;
	    padding-right: 10px;
	}
	.sm-sum {
		display: block
	}
	.spc__item-pay-name { font-size: 13px }
	.spc__item-logo,
	.spc__item-selector { display: none }
	.spc__item-info {
		flex: 0 0 190px;
		border-radius: 0 6px 6px 0;
	}
	.spc__item-trash {
		position: absolute;
		bottom: 0;
		right: 0;
		color: red;		
		width: 40px;
		text-align: center;
	}
}

@media (max-width: 414px) {
	.spc__item-text {
		flex: 0 0 calc(100% - 150px);
	}
	.spc__item-info {
		flex: 0 0 150px;
	}
}
</style>



// WEBPACK FOOTER //
// savedPayments.vue?141af9df